<!-- Temporary Vue bridge for the wired timesheet panel. -->
<!-- Prefer Zone-based dialogs for future work instead of extending this wrapper further. -->

<template lang="pug">
div
  TimeEntriesSplitDialog(
    v-if="timeEntryReady"
    :show="show"
    :time-entry="timeEntry"
    :on-save="onSave"
    :on-delete="onDelete"
    @close="close"
  )
</template>

<script>
import { mapGetters } from 'vuex';
import { setMomentStartStop } from '~/utils/time_entry_utils';

export default {
  name: 'TimeEntriesSplitDialogWired',
  data() {
    return {
      panel: null,
      show: false,
      timeEntry: null,
    };
  },
  computed: {
    ...mapGetters(['currentZone']),
    timeEntryReady() {
      return !!(this.timeEntry?.start_time && this.timeEntry?.stop_time);
    },
  },
  created() {
    this.handleOpenRequest = (event) => {
      const timeEntry = this.normalizeTimeEntry(event.detail.timeEntry);

      if (!timeEntry) {
        return;
      }

      this.timeEntry = timeEntry;
      this.$store.dispatch('setSelectedTimeEntry', {timeEntry});
      this.show = true;
    };
  },
  mounted() {
    this.eventTarget = this.$el.closest('turbo-frame');
    this.eventTarget.addEventListener('open-time-entry-split', this.handleOpenRequest);
    this.panel = this.eventTarget.closest('[x-data]')._x_dataStack[0];
  },
  beforeUnmount() {
    this.eventTarget.removeEventListener('open-time-entry-split', this.handleOpenRequest);
  },
  methods: {
    normalizeTimeEntry(timeEntry) {
      if (!timeEntry) {
        return null;
      }

      return setMomentStartStop(timeEntry, this.currentZone.name);
    },
    onSave() {
      return setTimeout(() => this.panel.loadData(), 500);
    },
    onDelete() {
      this.panel.removeTimeEntryRow({ detail: { rowId: this.timeEntry.domId } });

      // delete is async, give it a second before loading summary
      return setTimeout(() => this.panel.loadData(), 1000);
    },
    close() {
      this.show = false;
    },
  },
};
</script>
